// extracted by mini-css-extract-plugin
module.exports = {"specs":"OfferShortSpecificationsAlt_specs__4HaOa"};